/**
 * Explicit chip label overrides for property_features paths.
 * Keys are dot-notation paths relative to the property_features object,
 * pointing to the parent of the .detected field.
 * These take the highest priority in buildDetectedChips().
 */
export const PROPERTY_FEATURE_CHIP_LABELS: Record<string, string> = {
  pool: "Pool",
  "pool.types.above_ground": "Pool (Above Ground)",
  "pool.types.hot_tub": "Hot Tub",
  "pool.types.in_ground": "Pool (In Ground)",
  vehicle: "Vehicle(s)",
  "vehicle.types.automobile": "Cars",
  "vehicle.types.boat": "Boats",
  water_slide: "Waterslide",
  diving_board: "Diving Board",
  sport_court: "Sport Court",
  playground: "Playground",
  deck: "Deck",
  trampoline: "Trampoline",
  enclosure: "Enclosure",
};
